import React, { useContext, useEffect, useState } from "react"

import ProductRatings from "./ProductRatings"
import Reviews from "./Reviews"
import QuickBuyContext from "@context/QuickBuyContext"

const ProductReviewsSection = ({ ratings, reviews, isLoading, fitToSize }) => {
	const { setShowReviews, setShowWriteReview } = useContext(QuickBuyContext)

	const handleWriteReview = () => {
		setShowReviews(true)
		setShowWriteReview(true)
	}

	return (
		<React.Fragment>
			<div
				className={`${
					isLoading ? "block" : "hidden"
				} text-center text-md my-20`}
			>
				<div className="loader mx-auto"></div>
				<div className="pt-2 pl-2">Loading...</div>
			</div>

			{!isLoading && (
				<section className="max-container w-full px-4 lg:px-8 my-16 space-y-4">
					<div className="text-[1rem]">REVIEWS</div>
					<section className="grid grid-cols-6 w-full gap-x-4 lg:gap-x-16 gap-y-12 items-start">
						<ProductRatings
							className="col-span-6 md:col-span-3 lg:col-span-2"
							data={ratings}
						/>

						<div className="col-span-6 md:col-span-3 lg:col-span-2">
							{fitToSize && (
								<>
									<h1>Fits true to size</h1>
									<div className="flex flex-nowrap items-center gap-x-3 my-2">
										<span>Smaller</span>
										<div className="flex flex-1 gap-x-1">
											{[...Array(5)].map((_, index) => {
												return (
													<div
														key={`fit-true-${index}`}
														className={`h-2 flex-1 ${
															index === 2 ? "bg-primary" : "bg-[#D1D1D1]"
														}`}
													/>
												)
											})}
										</div>
										<span>Larger</span>
									</div>
									<div className="pt-4 spac-y-2">
										<div className="text-[#171717] text-md font-semibold mb-1">
											How is this calculated?
										</div>
										<p className="text-tertiary">
											We calculate the fit range rating by combining customer
											feedback, survey responses about fit, and precise product
											measurements to help you find the right size.
										</p>
									</div>
								</>
							)}
						</div>

						<div className="w-full flex col-span-6 lg:col-span-2">
							<button
								className="big-button"
								onClick={() => handleWriteReview()}
							>
								Write a Review
							</button>
						</div>
					</section>

					<Reviews data={reviews} />
				</section>
			)}
		</React.Fragment>
	)
}

export default ProductReviewsSection
